var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.7 31.6",
    enableBackground: "new 0 0 36.7 31.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#344154",
    d: "M19.4,23.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5c3.6,0,6.5-2.9,6.5-6.5S23,9.3,19.4,9.3 s-6.5,2.9-6.5,6.5c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5c0-4.2,3.4-7.5,7.5-7.5s7.5,3.4,7.5,7.5S23.5,23.3,19.4,23.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#344154",
    d: "M12.4,18.9l-2.5-2.5c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l1.8,1.8l1.8-1.8c0.2-0.2,0.5-0.2,0.7,0 s0.2,0.5,0,0.7L12.4,18.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendicon);
export default __webpack_public_path__ + "static/media/Resend icon.921282782b0d44d2be5022165ba783b6.svg";
export { ForwardRef as ReactComponent };